import React, { useState } from "react";
import { tabs } from "./socialCalendarConstants";
import { Link } from "react-router-dom";
import Select from "react-select";
import { reactSelectStyles } from "../../constants/StyleConstants";
import { GiSettingsKnobs } from "react-icons/gi";
import Tabs from "./Tabs";
import SocialDialog from "./SocialDialog";
import FilterDialog from "./FilterDialog";
import { FaSearch } from "react-icons/fa";
import SearchBox from "../../components/common/SearchBox";
import CommonBreadcrumb from "../../components/common/CommonBreadcrumb";
import { CSVLink } from "react-csv";
import {
  accountsTableHeaders
} from "./socialCalendarConstants";


const Navigation = ({ activeTab, setActiveTab, query, setQuery, tableAccountsData }) => {
  const [showFilters, setShowFilters] = useState(false);
  const [breadcrumb, setBreadcrumb] = useState([]);

  const isRecentPosts = activeTab === "RecentPosts";

  const handleBreadcrumbClick = (item, index) => {
    setBreadcrumb(breadcrumb.slice(0, index + 1));
  };

  const handleRootClick = () => {
    setBreadcrumb([]);
  };

  return (
    <div className="flex flex-col gap-5  pb-5">
      <h2 className="text-xl font-bold text-gray-800">Social Manager</h2>
      {/* <CommonBreadcrumb
        breadcrumb={breadcrumb}
        onBreadcrumbClick={handleBreadcrumbClick}
        rootName="Social Calendar"
        onRootClick={handleRootClick}
      /> */}

      <div
        className={`flex items-center gap-3 ${isRecentPosts ? "justify-between" : "w-full"
          }`}
      >
        {/* <div className={`relative ${isRecentPosts ? "w-[50%]" : "w-full"}`}>
          <FaSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs" />
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search"
            className="outline-none text-sm border border-gray-300 text-gray-500 w-full py-1 px-8 rounded-sm"
          />
        </div> */}
        <div className={`${isRecentPosts ? "w-[50%]" : "w-full"}`}>
          <SearchBox query={query} setQuery={setQuery} />
        </div>

        {isRecentPosts && (
          <div className="flex gap-3 items-center">
            <div className="w-[200px]">
              <Select
                placeholder="Select"
                options={[
                  { label: "Outlet 1", value: "1" },
                  { label: "Outlet 2", value: "2" },
                ]}
                styles={reactSelectStyles}
              />
            </div>
            <Link
              to="/social_calendar/new_post"
              className="py-[6px] px-2 w-[110px] font-medium text-white text-nowrap text-sm transition-all duration-300 hover:bg-black bg-[#1890FF] shadow-sm rounded flex items-center justify-center"
            >
              + New Post
            </Link>
          </div>
        )}

        {activeTab === "Accounts" && (
          <>
            {/* <button
              onClick={() => setShowFilters((p) => !p)}
              className="border border-gray-400 rounded-sm hover:-translate-y-1 transition-all duration-300 hover:bg-gray-200 cursor-pointer py-[6px] px-2"
            >
              <GiSettingsKnobs className="rotate-90 text-gray-700 text-sm font-bold" />
            </button> */}
            <CSVLink

              headers={accountsTableHeaders}
              data={tableAccountsData || []}
              filename={`accounts_data.csv`}
            >
              <button className="text-xs transition-all duration-300 bg-[#3b82f6] hover:bg-[#2563eb] text-white py-[7px] px-3 rounded-sm whitespace-nowrap">
                Download
              </button>
            </CSVLink>
          </>
        )}
      </div>

      <div className="mt-2">
        <Tabs tabs={tabs} aTab={activeTab} sTab={(v) => setActiveTab(v)} />
      </div>

      <SocialDialog
        isOpen={showFilters}
        onClose={() => setShowFilters(false)}
        title="Sort & Filter"
        content={<FilterDialog />}
      />
    </div>
  );
};

export default Navigation;
